export default __webpack_public_path__ + "static/media/microsoftLogo.80ea89c4.png";